import { useQueryClient } from "@tanstack/react-query";
import { Radio } from "antd";
import { RadioChangeEvent } from "antd/lib";
import { useTranslation } from "react-i18next";
import { apiInstance } from "shared/api";
import { languages } from "shared/i18n/i18n";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const queryClient = useQueryClient();

  const onChange = (e: RadioChangeEvent) => {
    i18n.changeLanguage(e.target.value);
    localStorage.setItem("language", e.target.value);

    apiInstance.interceptors.request.use((config) => {
      config.headers.set("user-lang", e.target.value);
      return config;
    });
    queryClient.invalidateQueries({ queryKey: ["profile"] });
  };

  return (
    <Radio.Group
      vertical
      onChange={onChange}
      value={i18n.language}
      options={Object.values(languages).map((lang) => ({
        value: lang.code,
        label: lang.name,
      }))}
    />
  );
};
